import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [{
  name: 'menu.workbench',
  key: 'workbench',
  children: [{
    name: 'menu.workbench.home',
    key: 'workbench/home',
    keepAlive: true
  }
  // {
  //   name: 'menu.workbench.agent',
  //   key: 'workbench/agent',
  //   keepAlive: true,
  //   requiredPermissions: [
  //     { resource: 'workbench.agent', actions: ['VIEW'] },
  //   ],
  // },
  ]
}, {
  name: 'menu.system',
  key: 'system',
  children: [{
    name: 'menu.system.ops',
    key: 'system/ops',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'ops.corp',
      actions: ['VIEW']
    }]
  }]
}, {
  name: 'menu.sales',
  key: 'sales',
  children: [{
    name: 'menu.sales.order',
    key: 'sales/sales',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'sales.all',
      actions: ['VIEW']
    }, {
      resource: 'sales',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.sales.orderDetail',
    key: 'sales/salesDetail/:sales_order_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'sales',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.sales.delivery',
    key: 'sales/delivery',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'sales.dispatch',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.sales.deliveryDetail',
    key: 'sales/deliveryDetail/:outbound_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'sales.dispatch',
      actions: ['VIEW']
    }]
  }]
}, {
  name: 'menu.plan',
  key: 'plan',
  children: [{
    name: 'menu.plan.request',
    key: 'plan/request',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'plan.request',
      actions: ['VIEW']
    }, {
      resource: 'plan.request.all',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.plan.requestDetail',
    key: 'plan/requestDetail/:request_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'plan.request',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.plan.issueDetail',
    key: 'plan/issueDetail/:outbound_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'plan.request.outbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.plan.plan',
    key: 'plan/plan',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'plan',
      actions: ['VIEW']
    }, {
      resource: 'plan.material',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }],
  oneOfPerm: true
}, {
  name: 'menu.purchase',
  key: 'purchase',
  children: [{
    name: 'menu.purchase.comparison',
    key: 'purchase/comparison',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'purchase.purchase',
      actions: ['ADD']
    }, {
      resource: 'bidding.purchase',
      actions: ['PUBLISH']
    }, {
      resource: 'inquiry.purchase',
      actions: ['PUBLISH']
    }, {
      resource: 'bidding.supplier',
      actions: ['VIEW']
    }, {
      resource: 'inquiry.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.purchase.order',
    key: 'purchase/order',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'purchase.purchase',
      actions: ['VIEW']
    }, {
      resource: 'purchase.purchase.all',
      actions: ['VIEW']
    }, {
      resource: 'purchase.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.purchase.priceHistory',
    key: 'purchase/priceHistory/:material_code',
    ignore: true,
    requiredPermissions: [{
      resource: 'purchase.purchase',
      actions: ['VIEW']
    }, {
      resource: 'purchase.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.purchase.orderDetail',
    key: 'purchase/orderDetail/:order_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'purchase.purchase',
      actions: ['VIEW']
    }, {
      resource: 'purchase.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.purchase.statement',
    key: 'purchase/statement',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'statement.purchase',
      actions: ['VIEW']
    }, {
      resource: 'statement.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }]
}, {
  name: 'menu.delivery',
  key: 'delivery',
  children: [{
    name: 'menu.delivery.follow',
    key: 'delivery/follow',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'delivery.purchase',
      actions: ['VIEW']
    }, {
      resource: 'dispatch.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.orderDetail',
    key: 'delivery/orderDetail/:order_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'dispatch.supplier',
      actions: ['VIEW']
    }, {
      resource: 'delivery.purchase',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.delivery',
    key: 'delivery/delivery',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'dispatch.supplier',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.delivery.receive',
    key: 'delivery/receive',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'receipt.purchase',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.delivery.receiveHistory',
    key: 'delivery/receiveHistory/:order_id?/:order_no?',
    ignore: true,
    requiredPermissions: [{
      resource: 'receipt.purchase',
      actions: ['VIEW']
    }, {
      resource: 'dispatch.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.receiveDetail',
    key: 'delivery/receiveDetail/:receipt_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'receipt.purchase',
      actions: ['VIEW']
    }, {
      resource: 'dispatch.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.inspect',
    key: 'delivery/inspect',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'inspect.purchase',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.delivery.return',
    key: 'delivery/return',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'return.purchase',
      actions: ['VIEW']
    }, {
      resource: 'return.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.returnHistory',
    key: 'delivery/returnHistory/:order_id?/:order_no?',
    ignore: true,
    requiredPermissions: [{
      resource: 'return.purchase',
      actions: ['VIEW']
    }, {
      resource: 'return.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.returnDetail',
    key: 'delivery/returnDetail/:return_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'return.purchase',
      actions: ['VIEW']
    }, {
      resource: 'return.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.delivery.fee',
    key: 'delivery/fee/:supplier_id/:biz_id?/:biz_no?/:biz_type?',
    ignore: true,
    requiredPermissions: [{
      resource: 'fee.purchase',
      actions: ['VIEW']
    }, {
      resource: 'fee.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }]
}, {
  name: 'menu.produce',
  key: 'produce',
  children: [{
    name: 'menu.produce.ticket',
    key: 'produce/ticket',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'produce.ticket',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.produce.ticketDetail',
    key: 'produce/ticketDetail/:ticket_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'produce.ticket',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.produce.ticketTransfer',
    key: 'produce/ticketTransfer',
    ignore: true,
    requiredPermissions: [{
      resource: 'produce.material.transfer',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.produce.ecn',
    key: 'produce/ecn',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'produce.ecn',
      actions: ['VIEW']
    }, {
      resource: 'produce.ecn.all',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.produce.ecnDetail',
    key: 'produce/ecnDetail/:ecn_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'produce.ecn',
      actions: ['VIEW']
    }]
  }]
}, {
  name: 'menu.warehouse',
  key: 'warehouse',
  children: [{
    name: 'menu.warehouse.inbound',
    key: 'warehouse/inbound',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'warehouse.inbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.outbound',
    key: 'warehouse/outbound',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'warehouse.outbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.inboundDetail',
    key: 'warehouse/inboundDetail/:inbound_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.inbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.outboundDetail',
    key: 'warehouse/outboundDetail/:outbound_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.outbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.inboundHistory',
    key: 'warehouse/inboundHistory',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.inbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.outboundHistory',
    key: 'warehouse/outboundHistory',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.outbound',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.stock',
    key: 'warehouse/stock',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'warehouse.stock',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.zone',
    key: 'warehouse/zone',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.zone',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.counting',
    key: 'warehouse/counting/:warehouse_id/:zone_code',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.counting',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.warehouse.disassemblyEdit',
    key: 'warehouse/disassemblyEdit',
    ignore: true,
    requiredPermissions: [{
      resource: 'warehouse.inbound',
      actions: ['ADD']
    }]
  }]
}, {
  name: 'menu.finance',
  key: 'finance',
  children: [{
    name: 'menu.finance.setup',
    key: 'finance/setup',
    requiredPermissions: [{
      resource: 'finance.setup',
      actions: ['VIEW']
    }, {
      resource: 'finance.usage',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.finance.fee',
    key: 'finance/fee',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'fee.purchase',
      actions: ['VIEW']
    }, {
      resource: 'fee.supplier',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.finance.payment',
    key: 'finance/payment',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'payment.purchase',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.finance.report',
    key: 'finance/report',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'warehouse.cost',
      actions: ['VIEW']
    }, {
      resource: 'warehouse.profit',
      actions: ['VIEW']
    }, {
      resource: 'warehouse.allocation',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }]
}, {
  name: 'menu.product',
  key: 'product',
  children: [{
    name: 'menu.product.material',
    key: 'product/material',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'product.material',
      actions: ['VIEW']
    }, {
      resource: 'product.substitute',
      actions: ['VIEW']
    }, {
      resource: 'material.category',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.product.materialHistory',
    key: 'product/materialHistory/:material_code',
    ignore: true,
    requiredPermissions: [{
      resource: 'product.material',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.product.bom',
    key: 'product/bom',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'product.bom',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.product.bomDetail',
    key: 'product/bomDetail/:bom_id',
    ignore: true,
    requiredPermissions: [{
      resource: 'product.bom',
      actions: ['VIEW']
    }]
  }]
}, {
  name: 'menu.corp',
  key: 'corp',
  children: [{
    name: 'menu.corp.general',
    key: 'corp/general',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.general.auth',
      actions: ['VIEW']
    }, {
      resource: 'corp.app',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.corp.organization',
    key: 'corp/organization',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.dept',
      actions: ['VIEW']
    }, {
      resource: 'corp.role',
      actions: ['VIEW']
    }, {
      resource: 'corp.emp',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.corp.supplier',
    key: 'corp/supplier',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.supplier',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.corp.customer',
    key: 'corp/customer',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.customer',
      actions: ['VIEW']
    }, {
      resource: 'corp.customer.all',
      actions: ['VIEW']
    }],
    oneOfPerm: true
  }, {
    name: 'menu.corp.address',
    key: 'corp/address',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.address',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.corp.contact',
    key: 'corp/contact',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.contact',
      actions: ['VIEW']
    }]
  }, {
    name: 'menu.corp.log',
    key: 'corp/log',
    keepAlive: true,
    requiredPermissions: [{
      resource: 'corp.log',
      actions: ['VIEW']
    }]
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }
      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = {
          ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({
          ...route
        });
      }
    }
    return arr;
  };
  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};
export default useRoute;